import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  gap: 0;
  height: 600px;
`;

export const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 24px;
`;

export const RightColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 24px;
  border-left: 1px solid #e2e8f0;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #002244;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CounterTag = styled.span`
  background-color: #e2e8f0;
  color: #002244;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  color: #64748b;
  margin: 0;
`;

export const CategoryTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const CategoryTag = styled.div`
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${({ $active }) => ($active ? "#002244" : "#f1f5f9")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#64748b")};
  border: 1px solid ${({ $active }) => ($active ? "#002244" : "#e2e8f0")};

  &:hover {
    background-color: ${({ $active }) => ($active ? "#003366" : "#e2e8f0")};
  }
`;

export const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  height: 450px;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const ProductItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
`;

export const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProductName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
`;

export const ProductDescription = styled.span`
  font-size: 13px;
  color: #64748b;
`;

export const ProductActions = styled.div`
  display: flex;
  align-items: center;
`;

export const AddButton = styled.button`
  padding: 8px 20px;
  background-color: ${({ disabled }) => (disabled ? "#e2e8f0" : "#002244")};
  color: ${({ disabled }) => (disabled ? "#94a3b8" : "#ffffff")};
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s;

  &:hover {
    background-color: ${({ disabled }) => (disabled ? "#e2e8f0" : "#003366")};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 400px;
  gap: 16px;
`;

export const EmptyProductsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 105px;
  gap: 16px;
  min-height: 200px;
`;

export const EmptyIcon = styled.div`
  font-size: 64px;
  color: #cbd5e1;

  svg {
    width: 64px;
    height: 64px;
  }
`;

export const EmptyText = styled.p`
  font-size: 14px;
  color: #64748b;
  text-align: center;
  max-width: 250px;
  line-height: 1.6;

  strong {
    color: #002244;
    font-weight: 600;
  }
`;

export const SelectedProductsList = styled(ProductsList)`
  height: auto;
  max-height: 500px;
`;

export const SelectedProductItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
`;

export const ProductLeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ProductIcon = styled.div`
  font-size: 24px;
  color: #002244;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #003366;
    transform: scale(1.1);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ProductRightSide = styled.div`
  display: flex;
  align-items: center;
`;

export const DeleteIcon = styled.div`
  font-size: 18px;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #dc2626;
    transform: scale(1.1);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
`;

export const CancelButton = styled.button`
  padding: 8px 20px;
  background-color: #e2e8f0;
  color: #64748b;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;

  &:hover {
    background-color: #cbd5e1;
  }
`;

export const SaveButton = styled.button`
  padding: 8px 20px;
  background-color: ${({ disabled }) => (disabled ? "#e2e8f0" : "#002244")};
  color: ${({ disabled }) => (disabled ? "#94a3b8" : "#ffffff")};
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s;
  text-transform: uppercase;

  &:hover {
    background-color: ${({ disabled }) => (disabled ? "#e2e8f0" : "#003366")};
  }
`;
